import { Navigate, Outlet } from "react-router-dom";
import { LOGIN } from "../../constants/routs.constants";

const PrivateRoute = ({
  authed,
  user,
  requireAdmin = false,
  redirectTo = LOGIN,
}) => {
  if (!authed) {
    return <Navigate to={LOGIN} />;
  }
  if (requireAdmin && !user?.is_staff) return <Navigate to={redirectTo} />;

  return <Outlet />;
};

export default PrivateRoute;
